<template>
    <div class="artist-library overflow-y-auto h-screen-header" ref="artistview">
        <section class="artist-hero">
            <div class="artist-hero__copy">
                <div class="artist-hero__label">{{ $tt('艺术家收藏') }}</div>
                <h1>{{ $tt('从艺术家进入整座音乐库') }}</h1>
                <p>{{ $tt('按专辑数量、名称和封面状态浏览，把常听的人和待整理的资料清楚分开。') }}</p>
            </div>
            <div class="artist-hero__stage" aria-hidden="true">
                <div class="artist-orbit">
                    <div
                        v-for="(image, index) in heroImages"
                        :key="index"
                        class="artist-orbit__avatar"
                        :style="{ '--avatar-index': index }"
                    >
                        <img :src="image" alt="">
                    </div>
                    <div class="artist-orbit__core">
                        <strong>{{ items.length }}</strong>
                        <span>{{ $tt('艺术家') }}</span>
                    </div>
                </div>
            </div>
        </section>

        <section class="artist-toolbar">
            <div class="artist-toolbar__tabs scrollbar-hide">
                <button
                    v-for="{ value, text } in options"
                    :key="value"
                    type="button"
                    :class="['artist-tab', sortValue === value ? 'is-active' : '']"
                    @click="handleTabClick(value)"
                >
                    {{ $tt(text) }}
                </button>
            </div>
            <div class="artist-toolbar__actions">
                <button
                    type="button"
                    :class="['artist-icon-button', showMode === 'grid' ? 'is-active' : '']"
                    :title="$tt('网格视图')"
                    @click="showMode = 'grid'"
                >
                    <svg class="icon w-5 h-5 fill-current" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                        <path d="M170.666667 85.333333a85.333333 85.333333 0 0 0-85.333334 85.333334v213.333333a85.333333 85.333333 0 0 0 85.333334 85.333333h213.333333a85.333333 85.333333 0 0 0 85.333333-85.333333V170.666667a85.333333 85.333333 0 0 0-85.333333-85.333334H170.666667zM170.666667 554.666667a85.333333 85.333333 0 0 0-85.333334 85.333333v213.333333a85.333333 85.333333 0 0 0 85.333334 85.333334h213.333333a85.333333 85.333333 0 0 0 85.333333-85.333334v-213.333333a85.333333 85.333333 0 0 0-85.333333-85.333333H170.666667zM640 85.333333a85.333333 85.333333 0 0 0-85.333333 85.333334v213.333333a85.333333 85.333333 0 0 0 85.333333 85.333333h213.333333a85.333333 85.333333 0 0 0 85.333334-85.333333V170.666667a85.333333 85.333333 0 0 0-85.333334-85.333334h-213.333333zM640 554.666667a85.333333 85.333333 0 0 0-85.333333 85.333333v213.333333a85.333333 85.333333 0 0 0 85.333333 85.333334h213.333333a85.333333 85.333333 0 0 0 85.333334-85.333334v-213.333333a85.333333 85.333333 0 0 0-85.333334-85.333333h-213.333333z"></path>
                    </svg>
                </button>
                <button
                    type="button"
                    :class="['artist-icon-button', showMode === 'list' ? 'is-active' : '']"
                    :title="$tt('列表视图')"
                    @click="showMode = 'list'"
                >
                    <svg class="icon w-5 h-5 fill-current" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                        <path d="M134.976 853.312H89.6c-26.56 0-46.912-20.928-46.912-48.256 0-27.392 20.352-48.32 46.912-48.32h45.376c26.624 0 46.912 20.928 46.912 48.32 0 27.328-20.288 48.256-46.912 48.256zM134.976 560.32H89.6C63.04 560.32 42.688 539.392 42.688 512s20.352-48.32 46.912-48.32h45.376c26.624 0 46.912 20.928 46.912 48.32s-20.288 48.32-46.912 48.32zM134.976 267.264H89.6c-26.56 0-46.912-20.928-46.912-48.32 0-27.328 20.352-48.256 46.912-48.256h45.376c26.624 0 46.912 20.928 46.912 48.256 0 27.392-20.288 48.32-46.912 48.32zM311.744 853.312c-26.56 0-46.912-20.928-46.912-48.256 0-27.392 20.352-48.32 46.912-48.32h622.72c26.56 0 46.848 20.928 46.848 48.32 0 27.328-20.288 48.256-46.912 48.256H311.744c1.6 0 1.6 0 0 0zM311.744 560.32c-26.56 0-46.912-20.928-46.912-48.32s20.352-48.32 46.912-48.32h622.72c26.56 0 46.848 20.928 46.848 48.32s-20.288 48.32-46.912 48.32H311.744c1.6 0 1.6 0 0 0zM311.744 267.264c-26.56 0-46.912-20.928-46.912-48.32 0-27.328 20.352-48.256 46.912-48.256h622.72c26.56 0 46.848 20.928 46.848 48.256 0 27.392-20.288 48.32-46.912 48.32H311.744c1.6 0 1.6 0 0 0z"></path>
                    </svg>
                </button>
            </div>
        </section>

        <section class="artist-status-strip">
            <div>
                <span class="artist-status-strip__label">{{ $tt('当前规则') }}</span>
                <strong>{{ currentSortLabel }}</strong>
            </div>
            <div>
                <span class="artist-status-strip__label">{{ $tt('已载入') }}</span>
                <strong>{{ items.length }}</strong>
            </div>
            <div>
                <span class="artist-status-strip__label">{{ $tt('专辑总数') }}</span>
                <strong>{{ totalAlbumCount }}</strong>
            </div>
        </section>

        <section class="artist-content">
            <ArtistList :items="items" v-if="showMode === 'grid' && items.length" />
            <ArtistItems :items="items" v-if="showMode === 'list' && items.length" />

            <div v-if="loading" class="artist-loading">
                <div class="artist-loading__grid">
                    <span v-for="index in 8" :key="index"></span>
                </div>
                <p>{{ $tt('正在载入艺术家') }}</p>
            </div>

            <div v-if="!loading && items.length === 0" class="artist-empty">
                <div class="artist-empty__art">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <h3>{{ $tt('暂无艺术家') }}</h3>
                <p>{{ $tt('还没有找到任何艺术家，可以切换排序或调整搜索关键词。') }}</p>
            </div>
        </section>

        <button v-if="curScrollTop > 700" @click="scrollToTop" class="artist-scroll-top" :title="$tt('返回顶部')">
            <svg class="icon h-5 w-5 fill-current" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                <path d="M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3c-3.8 5.3-0.1 12.7 6.5 12.7h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"></path>
            </svg>
        </button>
    </div>
</template>

<script>
import ArtistList from './ArtistList.vue'
import ArtistItems from './ArtistItems.vue'
import { mapGetters } from "vuex";

export default {
    name: 'artists',
    components: {
        ArtistList,
        ArtistItems
    },
    props: {
        sort: { type: String, default: null }
    },
    data() {
        return {
            loading: true,
            hasMore: true,
            options: [
                { text: '最多专辑', value: 'most-albums' },
                { text: 'A-Z排序', value: 'a-z' },
                { text: '缺失封面', value: 'less_cover' }
            ],
            items: [],
            showMode: 'grid',
            offset: 0,
            curScrollTop: 0,
            watchSearchTerm: null,
            searchTimeout: null
        }
    },
    computed: {
        ...mapGetters(['getSearchTerm']),
        sortValue: {
            get() {
                return this.$route.params.sort
            }
        },
        currentSortLabel() {
            const option = this.options.find(item => item.value === this.sortValue)
            return option ? this.$tt(option.text) : this.$tt('最多专辑')
        },
        totalAlbumCount() {
            return this.items.reduce((sum, item) => sum + Number(item.albumCount || 0), 0)
        },
        heroImages() {
            const images = this.items
                .filter(artist => artist && artist.image)
                .slice(0, 6)
                .map(artist => artist.image)

            while (images.length < 6) {
                images.push('/static/dist/img/album_null.jpg')
            }
            return images
        }
    },
    async created() {
        this.loadMore()
        this.startWatching()
    },
    beforeDestroy() {
        this.stopWatching()
        if (window.artistview) {
            window.artistview.removeEventListener('scroll', this.listenBottomOut, false)
        }
    },
    activated() {
        this.$refs.artistview.addEventListener('scroll', this.listenBottomOut)
        window.artistview = this.$refs.artistview
        window.artistview.scrollTop = this.curScrollTop || 0
        this.startWatching()
    },
    deactivated() {
        window.artistview.removeEventListener('scroll', this.listenBottomOut, false)
        this.stopWatching()
    },
    methods: {
        startWatching() {
            if (!this.watchSearchTerm) {
                this.watchSearchTerm = this.$watch('getSearchTerm', this.loadSearchTimeout);
            }
        },
        stopWatching() {
            if (this.watchSearchTerm) {
                this.watchSearchTerm()
                this.watchSearchTerm = null
            }
        },
        handleTabClick(value) {
            if (this.sortValue === value) {
                this.resetArtistFeed()
                return
            }
            this.$router.push({ path: '/artists/' + value })
        },
        resetArtistFeed() {
            this.offset = 0
            this.items = []
            this.hasMore = true
            return this.loadMore()
        },
        loadSearch() {
            if (this.getSearchTerm === '') {
                this.resetArtistFeed()
                return
            }
            this.loading = true
            this.offset = 0
            this.hasMore = false
            this.$api.subsonic.searchArtists('search', this.getSearchTerm).then(artists => {
                this.items = artists
                this.loading = false
            }).catch((err) => {
                this.loading = false
                if (err.message !== 'Wrong username or password.') {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: err.messagee ? err.message : this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            })
        },
        loadSearchTimeout() {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout)
            }
            this.searchTimeout = setTimeout(() => {
                this.searchTimeout = null
                this.loadSearch()
            }, 300)
        },
        loadMore() {
            this.loading = true
            return this.$api.subsonic.getArtists(this.sortValue, 50, this.offset).then(artists => {
                this.items.push(...artists)
                this.offset += artists.length
                this.hasMore = artists.length > 0
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        listenBottomOut() {
            if (this.hasMore && !this.loading) {
                const scrollTop = window.artistview.scrollTop || document.body.scrollTop
                const scrollHeight = window.artistview.scrollHeight || document.body.scrollHeight
                const clientHeight = window.artistview.clientHeight || document.body.clientHeight
                this.curScrollTop = scrollTop
                if (scrollTop + clientHeight >= scrollHeight - 50) {
                    this.loadMore()
                }
            }
        },
        scrollToTop() {
            window.artistview.scrollTop = 0
        }
    }
}
</script>

<style scoped>
.artist-library {
    --artist-radius: 18px;
    --artist-border: oklch(var(--bc) / 0.12);
    --artist-muted: oklch(var(--bc) / 0.62);
    --artist-soft: color-mix(in oklch, oklch(var(--b2)) 72%, transparent);
    min-height: 0;
    overflow-x: hidden;
    border-radius: 1rem;
    color: oklch(var(--bc));
    background:
        radial-gradient(circle at 12% 8%, color-mix(in srgb, oklch(var(--p)) 16%, transparent), transparent 28rem),
        radial-gradient(circle at 88% 4%, color-mix(in srgb, oklch(var(--a)) 12%, transparent), transparent 26rem),
        oklch(var(--b2));
    padding: 18px;
}

.artist-hero,
.artist-toolbar,
.artist-status-strip,
.artist-content {
    max-width: 1480px;
    margin-left: auto;
    margin-right: auto;
}

.artist-hero {
    position: relative;
    display: grid;
    grid-template-columns: minmax(0, 1.3fr) minmax(260px, 0.7fr);
    gap: 28px;
    align-items: stretch;
    min-height: 220px;
    margin-bottom: 14px;
    border: 1px solid var(--artist-border);
    border-radius: var(--artist-radius);
    background:
        radial-gradient(circle at 86% 18%, color-mix(in oklch, oklch(var(--p)) 18%, transparent), transparent 24rem),
        linear-gradient(
            105deg,
            oklch(var(--b1) / 0.98) 0%,
            oklch(var(--b1) / 0.96) 42%,
            color-mix(in oklch, oklch(var(--b2)) 88%, oklch(var(--p)) 6%) 68%,
            color-mix(in oklch, oklch(var(--b3)) 84%, oklch(var(--p)) 10%) 100%
        ),
        oklch(var(--b1));
    box-shadow: 0 20px 60px oklch(var(--bc) / 0.08);
    isolation: isolate;
    overflow: hidden;
}

.artist-hero__copy {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: clamp(24px, 4vw, 44px);
}

.artist-hero__label {
    width: fit-content;
    margin-bottom: 14px;
    padding: 5px 10px;
    border-radius: 999px;
    background: oklch(var(--p) / 0.14);
    color: oklch(var(--p));
    font-size: 12px;
    font-weight: 700;
}

.artist-hero h1 {
    max-width: 660px;
    margin: 0;
    font-size: clamp(30px, 4vw, 54px);
    line-height: 1.04;
    font-weight: 800;
    letter-spacing: 0;
}

.artist-hero p {
    max-width: 56ch;
    margin-top: 16px;
    color: var(--artist-muted);
    font-size: 15px;
    line-height: 1.75;
}

.artist-hero__stage {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 220px;
    background: transparent;
    isolation: isolate;
    overflow: hidden;
}

.artist-hero__stage::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 0;
    background:
        linear-gradient(
            90deg,
            transparent 0%,
            color-mix(in oklch, oklch(var(--b3)) 42%, transparent) 46%,
            color-mix(in oklch, oklch(var(--b3)) 68%, oklch(var(--p)) 8%) 100%
        );
    pointer-events: none;
}

.artist-orbit {
    position: relative;
    z-index: 1;
    width: min(310px, 82vw);
    aspect-ratio: 1;
}

.artist-orbit__avatar {
    position: absolute;
    width: 82px;
    aspect-ratio: 1;
    left: 50%;
    top: 50%;
    border: 1px solid oklch(var(--bc) / 0.16);
    border-radius: 999px;
    background: oklch(var(--b2));
    box-shadow: 0 16px 38px oklch(var(--bc) / 0.22);
    transform:
        rotate(calc(var(--avatar-index) * 60deg))
        translate(112px)
        rotate(calc(var(--avatar-index) * -60deg))
        translate(-50%, -50%);
    overflow: hidden;
}

.artist-orbit__avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.artist-orbit__core {
    position: absolute;
    inset: 50%;
    display: flex;
    width: 118px;
    height: 118px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid oklch(var(--bc) / 0.12);
    border-radius: 50%;
    background: oklch(var(--b1) / 0.9);
    box-shadow: inset 0 1px 0 oklch(var(--bc) / 0.08);
    transform: translate(-50%, -50%);
}

.artist-orbit__core strong {
    font-size: 30px;
    line-height: 1;
}

.artist-orbit__core span {
    margin-top: 6px;
    color: var(--artist-muted);
    font-size: 12px;
}

.artist-toolbar {
    position: sticky;
    top: 0;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 12px;
    align-items: center;
    margin-bottom: 12px;
    padding: 10px;
    border: 1px solid var(--artist-border);
    border-radius: var(--artist-radius);
    background: color-mix(in oklch, oklch(var(--b1)) 92%, transparent);
    backdrop-filter: blur(14px);
    z-index: 3;
}

.artist-toolbar__tabs {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 1px;
}

.artist-tab,
.artist-icon-button {
    min-height: 38px;
    border-radius: 999px;
    border: 1px solid transparent;
    background: transparent;
    color: oklch(var(--bc) / 0.72);
    transition: background-color 180ms ease, color 180ms ease, border-color 180ms ease, transform 180ms ease;
}

.artist-tab {
    flex: 0 0 auto;
    padding: 0 14px;
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
}

.artist-tab:hover,
.artist-icon-button:hover {
    background: oklch(var(--b2));
    color: oklch(var(--bc));
}

.artist-tab:active,
.artist-icon-button:active,
.artist-scroll-top:active {
    transform: translateY(1px);
}

.artist-tab.is-active,
.artist-icon-button.is-active {
    background: oklch(var(--p));
    color: oklch(var(--pc));
    border-color: oklch(var(--p));
}

.artist-toolbar__actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.artist-icon-button {
    display: inline-flex;
    width: 40px;
    align-items: center;
    justify-content: center;
}

.artist-status-strip {
    display: grid;
    grid-template-columns: 1.4fr 1fr 1fr;
    gap: 10px;
    margin-bottom: 12px;
}

.artist-status-strip > div {
    min-width: 0;
    padding: 14px 16px;
    border: 1px solid var(--artist-border);
    border-radius: 16px;
    background: var(--artist-soft);
}

.artist-status-strip__label {
    display: block;
    margin-bottom: 3px;
    color: var(--artist-muted);
    font-size: 12px;
}

.artist-status-strip strong {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 18px;
}

.artist-content {
    padding: 2px 0 28px;
}

.artist-loading,
.artist-empty {
    display: flex;
    min-height: 260px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    border: 1px solid var(--artist-border);
    border-radius: var(--artist-radius);
    background: oklch(var(--b1) / 0.74);
    text-align: center;
}

.artist-loading__grid {
    display: grid;
    width: min(420px, 78vw);
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
}

.artist-loading__grid span {
    aspect-ratio: 1;
    border-radius: 999px;
    background: linear-gradient(110deg, oklch(var(--b2)), oklch(var(--b3)), oklch(var(--b2)));
    background-size: 200% 100%;
}

.artist-loading p,
.artist-empty p {
    max-width: 36ch;
    color: var(--artist-muted);
    font-size: 14px;
}

.artist-empty__art {
    position: relative;
    width: 112px;
    height: 82px;
}

.artist-empty__art span {
    position: absolute;
    bottom: 0;
    width: 58px;
    height: 58px;
    border: 10px solid oklch(var(--bc) / 0.12);
    border-radius: 999px;
    background: oklch(var(--b2));
}

.artist-empty__art span:nth-child(1) {
    left: 0;
}

.artist-empty__art span:nth-child(2) {
    left: 27px;
    bottom: 18px;
    border-color: oklch(var(--p) / 0.42);
}

.artist-empty__art span:nth-child(3) {
    right: 0;
}

.artist-empty h3 {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
}

.artist-scroll-top {
    position: fixed;
    right: 24px;
    bottom: 24px;
    display: inline-flex;
    width: 44px;
    height: 44px;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: oklch(var(--p));
    color: oklch(var(--pc));
    box-shadow: 0 12px 30px oklch(var(--bc) / 0.2);
    transition: transform 180ms ease, background-color 180ms ease;
    z-index: 4;
}

.scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.scrollbar-hide::-webkit-scrollbar {
    display: none;
}

@media (prefers-reduced-motion: no-preference) {
    .artist-hero,
    .artist-toolbar,
    .artist-status-strip,
    .artist-content {
        animation: artistFadeIn 360ms ease both;
    }

    .artist-loading__grid span {
        animation: artistSkeleton 1.2s ease-in-out infinite;
    }
}

@keyframes artistFadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes artistSkeleton {
    0% {
        background-position: 100% 0;
    }
    100% {
        background-position: -100% 0;
    }
}

@media screen and (max-width: 900px) {
    .artist-library {
        padding: 12px;
    }

    .artist-hero {
        grid-template-columns: 1fr;
    }

    .artist-hero__stage {
        min-height: 190px;
    }

    .artist-toolbar {
        grid-template-columns: 1fr;
    }

    .artist-toolbar__actions {
        justify-content: flex-end;
    }
}

@media screen and (max-width: 640px) {
    .artist-hero__copy {
        padding: 22px;
    }

    .artist-hero h1 {
        font-size: 30px;
    }

    .artist-orbit {
        width: 238px;
    }

    .artist-orbit__avatar {
        width: 64px;
        transform:
            rotate(calc(var(--avatar-index) * 60deg))
            translate(86px)
            rotate(calc(var(--avatar-index) * -60deg))
            translate(-50%, -50%);
    }

    .artist-orbit__core {
        width: 96px;
        height: 96px;
    }

    .artist-status-strip {
        grid-template-columns: 1fr;
    }

    .artist-loading__grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .artist-scroll-top {
        right: 16px;
        bottom: 16px;
    }
}
</style>
